export enum Size {
  Large = 'large',
  Small = 'small',
  Medium = 'medium',
  ExtraSmall = 'extraSmall',
}
